import { NavLink } from 'react-router-dom';
import './_navbars.scss';

interface Props {
  to?: string;
  children?: any;
  className?: string;
  highlight?: boolean;
}

const NavbarLink: React.FC<Props> = ({ to, children, className, highlight }) => {
  if (to) {
    return (
      <NavLink to={to} className={(navData) => `${navData.isActive ? 'nav-link active' : 'nav-link'} ${highlight && 'highlighted box box-anim'}`}>
        <div className="navbar-item">{children}</div>
      </NavLink>
    );
  } else {
    return (
      <a className={`nav-link ${className}`}>
        <div className="navbar-item">{children}</div>
      </a>
    )
  }
};

export default NavbarLink;
